import styled from 'styled-components';

import { DiseaseAutosuggest } from '~libs.desktop.shared.visit-medical-documents.diagnoses';

export const StyledDiseaseField = styled(DiseaseAutosuggest)`
   width: 100%;
`;
